var map = {
	"./apprentissage.png": 7779,
	"./bringt.png": 219,
	"./british.png": 2938,
	"./children.png": 7374,
	"./classroom.jpeg": 1763,
	"./dekra_100.png": 9516,
	"./dhbw.png": 3846,
	"./etudiant.png": 1087,
	"./europaschule.png": 8915,
	"./goethe.png": 547,
	"./google.png": 6702,
	"./heureux.png": 2401,
	"./ihk.png": 7697,
	"./image_contact.jpg": 4969,
	"./image_test.jpg": 2017,
	"./konferenz.png": 3007,
	"./lang.png": 6607,
	"./novalingua.jpg": 7831,
	"./novalingua.png": 4071,
	"./salle_fete.png": 1941,
	"./students.jpg": 4019,
	"./tuvnord.png": 5061,
	"./zdh.png": 5637
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;